exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-preview {\n  text-align: center;\n  margin-bottom: 1.5rem; }\n  .label-preview h5 {\n    margin-bottom: 0.5rem; }\n\n.preview-image {\n  border: 3px dashed black;\n  border-radius: 5px;\n  max-width: 45%;\n  height: auto; }\n\n.error-message {\n  color: #dc3545; }\n\n.modal-header .close {\n  margin: 0; }\n\n.modal-footer {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  gap: 0.5rem;\n  background-color: #f8f9fa; }\n\n.modal-body {\n  max-height: 60vh;\n  width: 100%;\n  overflow: scroll; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/zpl-preview-modal/zpl-preview.modal.component.scss
// module id = ../../../../../src/app/shared/modals/zpl-preview-modal/zpl-preview.modal.component.scss
// module chunks = main